import React from 'react';
import * as Sentry from '@sentry/browser';
import configuration from '../../configuration/server';

class ErrorHandler extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
        this.isLocal = this.isLocal.bind(this);
    }

    isLocal() {
        const { STAGE } = configuration;
        const host = window.location.hostname;
        return ['localhost', '127.0.0.1'].includes(host) || STAGE === 'local';
    }

    componentDidMount() {
        if (this.isLocal()) return;

        const { STAGE } = configuration;
        const { key, project } = configuration[STAGE].sentry;
        Sentry.init({ dsn: `https://${key}@sentry.io/${project}` });
    }

    componentDidCatch(error, errorInfo) {
        if (this.isLocal()) return;

        this.setState({ error });
        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => scope.setExtra(key, errorInfo[key]));
            Sentry.captureException(error);
        });
    }

    render() {
        const { error } = this.state;
        const { children } = this.props;
        return error && !this.isLocal() ? <a onClick={() => Sentry.showReportDialog()}>Report feedback</a> : children;
    }
}

export default ErrorHandler;



// WEBPACK FOOTER //
// ./src/components/errorHandler/index.jsx